module.exports = __webpack_public_path__ + "media/images/no_user_image-83baa0315be6741cd3bfb282b6d50627.png";